import React from 'react';
import { Box } from '@mui/material';
import { useConfigurationContext } from '../../root/ConfigurationContext';

export const LogoHeader: React.FC = () => {
    const { logo, title } = useConfigurationContext();

    return (
        <Box
            sx={{
                py: 2,
                px: 2,
                textAlign: 'center',
            }}
        >
            {logo && (
                <img
                    src={logo}
                    alt={`${title} logo`}
                    style={{ height: '60px', maxWidth: '100%' }}
                />
            )}
        </Box>
    );
};
